/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGenerativeAi = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13.54 11.812h-2.047l-.34-1.165H9.06l-.331 1.164H6.756l2.48-6.722h1.806zm-4.075-2.59h1.271l-.643-2.206zM16 11.812h-1.843V5.089H16z" />
        <path d="M15.5 2A6.5 6.5 0 0 1 18 14.501v1.222l.894 1.489a3 3 0 1 1-1.524 1.347L16 16.277v-1.299a6.563 6.563 0 0 1-.5.022H13v1.174A2.998 2.998 0 0 1 12 22a3 3 0 0 1-1-5.826V15H8.5c-.168 0-.335-.009-.5-.022v1.3l-1.37 2.28a3 3 0 1 1-1.524-1.347L6 15.724V14.5A6.501 6.501 0 0 1 8.5 2zM4 19a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm16 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-8-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM8.5 4a4.5 4.5 0 0 0 0 9h7a4.5 4.5 0 1 0 0-9z" />
      </g>
    </g>
  </Icon>
);
export { SvgGenerativeAi as GenerativeAi };
